































import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';
// eslint-disable-next-line no-unused-vars
import { Column, arrayToTable } from '@/main/utils/table';

import { prepocetSj } from './utils';
import { PREPOCET_TYP } from './constants';

export default Vue.extend({
	name: 'CharakterSjDialog',
	props: {
		visible: { type: Boolean },
		storeModule: { type: String, default: '' },
	},
	data() {
		return {
			SkladMjIdList: [] as DropdownItem[],
			validationRules: {
				VydejMjPoc: { required: true, scale: 2, precision: 8, min: 0.01, type: 'number' },
			},
			PREPOCET_TYP,
			SkladMjId: null,
			VydejMjId: null,
			VydejMjPoc: null,
			Stav: null,
			StavRightValue: null as number | null,
			PcRightValue: null as number | null,
			PncRightValue: null as number | null,
		};
	},
	computed: {
		visibleCmp: {
			get() {
				return this.visible;
			},
			set() {
				this.hideModal();
			},
		},
		modalLabel(): string {
			return this.LocalizeFormular('dlgNDSkladedtSJ');
		},
		validator(): Function {
			return (this.$children[0].$refs.modalForm as any).validate;
		},
		tableCmp(): Record<string, any> {
			const { Stav, Pc, Pnc, SkladMjId } = this.$store.state.pages[this.storeModule].edit;
			const primarniMena = this.$store.state.loggedUser.OrganizaceData.PrimarniMena.Zkratka;
			const skladMjIdText = this.getSkladMjIdText(SkladMjId);
			const tableData = [
				{
					rowLabel: this.LocalizePopisPoli('STAV'),
					leftValue: Stav,
					leftUnit: skladMjIdText,
					textNa: this.LocalizePopisostatni('lblNa'),
					rightValue: this.StavRightValue!,
					rightUnit: this.getSkladMjIdText(this.SkladMjId),
				},
				{
					rowLabel: this.LocalizePopisPoli('PC'),
					leftValue: Pc,
					leftUnit: primarniMena,
					textNa: this.LocalizePopisostatni('lblNa'),
					rightValue: this.PcRightValue!,
					rightUnit: primarniMena,
				},
				{
					rowLabel: this.LocalizePopisPoli('PNC'),
					leftValue: Pnc,
					leftUnit: primarniMena,
					textNa: this.LocalizePopisostatni('lblNa'),
					rightValue: this.PncRightValue!,
					rightUnit: primarniMena,
				},
			];
			const tableTransformed = arrayToTable(tableData);
			tableTransformed.columns.forEach((col: Column) => { col.isVisible = true; });
			return tableTransformed;
		},
	},
	watch: {
		visible(newVisible) {
			if (newVisible) {
				// nemuzu inicializovat v data() {}, protoze modal je created pred nactenim dat
				this.initData();
			}
		},
	},
	methods: {
		initData() {
			const { Stav, Pc, Pnc, SkladMjId, VydejMjId, VydejMjPoc } = this.$store.state.pages[this.storeModule].edit;
			this.SkladMjIdList = this.$store.state.pages[this.storeModule].dropdownList.SkladMjId;

			this.SkladMjId = SkladMjId;
			this.VydejMjId = VydejMjId;
			this.VydejMjPoc = VydejMjPoc;
			this.Stav = Stav;

			this.StavRightValue = Stav;
			this.PcRightValue = Pc;
			this.PncRightValue = Pnc;
		},
		prepocetSj(newVydejMjPoc: number) {
			const { Stav, Pc, Pnc, VydejMjPoc } = this.$store.state.pages[this.storeModule].edit;
			this.StavRightValue = prepocetSj(VydejMjPoc, newVydejMjPoc, Stav, true);
			this.PcRightValue = prepocetSj(VydejMjPoc, newVydejMjPoc, Pc, false)!;
			this.PncRightValue = prepocetSj(VydejMjPoc, newVydejMjPoc, Pnc, false)!;
		},
		getSkladMjIdText(SkladMistoId: number | null) {
			const SkladMjIdItem = this.SkladMjIdList.find((skladMjId: DropdownItem) => skladMjId.Value === SkladMistoId);
			return SkladMjIdItem ? SkladMjIdItem.Text : null;
		},
		async prepoctiSj(prepocetTyp: PREPOCET_TYP) {
			const isValid = await this.validate();
			if (!isValid) {
				return;
			}
			this.$emit('ok-clicked', this.SkladMjId, this.VydejMjId, this.VydejMjPoc, prepocetTyp);
		},
		async validate() {
			let isValid;

			this.validator((valid: boolean) => {
				isValid = valid;

				valid || this.showErrorAlert({ message: 'InvalidForm' });
			});

			return isValid;
		},
		hideModal() {
			this.$emit('update:visible', false);
		},
	},
});
